module.exports = __webpack_public_path__ + "static/img/forReference.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forReference.png
// module id = 7o5o
// module chunks = 1